import { Box, Stack, Typography } from "@mui/joy";
import { PaymentButton } from "components/task/payment/elements";
import React, { useEffect, useRef, useState } from "react";
import pcAndMobileImg from "static/image/payment/pc_and_mobile.png";
import reviewAvatar1Img from "static/image/payment/review_avatar_1.svg";
import reviewAvatar2Img from "static/image/payment/review_avatar_2.svg";
import reviewAvatar3Img from "static/image/payment/review_avatar_3.svg";
import numWithCircle1Img from "static/image/payment/NumWithCircle_1.svg";
import numWithCircle2Img from "static/image/payment/NumWithCircle_2.svg";
import numWithCircle3Img from "static/image/payment/NumWithCircle_3.svg";
import numWithCircle4Img from "static/image/payment/NumWithCircle_4.svg";
import checkIconImg from "static/image/payment/Check.svg";
import paybackMarkImg from "static/image/onboarding/payback_guarantee.svg";
import focusCoachingImg from "static/image/onboarding/focus_coaching.svg";
import calendarForeverImg from "static/image/payment/calendar_forever.svg";
import muscleImg from "static/image/payment/muscle.svg";
import rocketImg from "static/image/payment/rocket.svg";
import manyImg from "static/image/payment/many.svg";
import cheaperImg from "static/image/payment/cheaper.svg";
import chartForeverImg from "static/image/payment/chart_forever.svg";
import sponsorImg from "static/image/payment/sponsor_payment.png";
import fivestarsImg from "static/image/onboarding/fivestars.svg";
import tool1Img from "static/image/payment/tool_1.svg";
import tool2Img from "static/image/payment/tool_2.svg";
import tool3Img from "static/image/payment/tool_3.svg";
import tool4Img from "static/image/payment/tool_4.svg";
import tool5Img from "static/image/payment/tool_5.svg";
import tool6Img from "static/image/payment/tool_6.svg";
import tool7Img from "static/image/payment/tool_7.svg";
import tool8Img from "static/image/payment/tool_8.svg";
import tool9Img from "static/image/payment/tool_9.svg";
import tool10Img from "static/image/payment/tool_10.svg";
import useGetDeviceInfo from "hooks/useGetDeviceInfo";
import useGetUrls from "hooks/useGetUrls";
import { sendMessage } from "utils/webview";
import useIsInappWebview from "hooks/useIsInappWebview";
import { theme } from "styles/theme";
import FloatingArea from "components/common/FloatingArea";
import { extractHexColor } from "../../../styles/hexOpacity";
import { useRecoilState } from "recoil";
import { paymentOrderAtom } from "../../../recoil/paymentOrderAtom";
import { useMutation, useQuery } from "@tanstack/react-query";
import {
  PAYMENT_DOMAIN,
  PAYMENT_ORDER_DETAIL_ENDPOINT,
  paymentApi,
} from "api/paymentApi";
import { userAtom } from "../../../recoil/userAtom";
import CustomTypography from "../../common/CustomTypography";
import { onboardingApi } from "../../../api/onboardingApi";
import CustomTypographyHighlight from "../../common/CustomTypographyHighlight";
import ContentTemplateV2 from "../content/ContentTemplateV2";
import UserInfo from "../../user/UserInfo";
import CxButton from "../../sidebar/CXButton";
import LinkV2 from "../../common/LinkV2";
import ReviewItem from "./elements/ReviewItem";
import { compareVersions } from "../../../logic/logics_common";
import { appsflyerApi } from "api/appsflyerApi";
import CompareWithCounselingTypeC from "./elements/CompareWithCounselingTypeC";
import FAQTypeC from "./elements/FAQTypeC";

const numberWithCircle = [
  numWithCircle1Img,
  numWithCircle2Img,
  numWithCircle3Img,
  numWithCircle4Img,
];

const majorTrainingPlan = [
  "알아차림과 주의력 통제하기",
  "생각을 심리적 사건으로 바라보기",
  "있는 그대로를 기꺼이 받아들이기",
  "가치를 발견하고 실천하기",
];

const programFeatures = [
  {
    main: "체계적인 인지심리학 이론 학습",
    postLabel: undefined,
  },
  {
    main: "100일간의 전담 코치의 1:1 지원",
    postLabel: undefined,
  },
  {
    main: "2주 간격의 트래킹 검사",
  },
  {
    main: "다양한 용도의 명상훈련지",
  },
  {
    main: "일상에서 연습할 생각기록지",
  },
];

interface ComparisonItem {
  type: "quantity" | "cost";
  title: string;
  text: string;
  icon: string;
}

const comparisonItems: ComparisonItem[] = [
  {
    type: "quantity",
    title: "심리상담보다\n3배 더 많이",
    text: "디스턴싱의 집중 코칭 기간에는 매일 30분 정도의 활동이 제공됩니다. 일주일에 약 150분에 달하는 시간이죠. 반면 일반적인 심리상담은 일주일에 50분만 진행합니다.",
    icon: manyImg,
  },
  {
    type: "cost",
    title: "심리상담보다\n3배 더 싸게",
    text: "디스턴싱의 집중 코칭 기간에는 매주 3만 원대에 선생님과 함께할 수 있습니다. 그것도 평일 내내 말이죠. 반면 일반적인 심리상담은 일주일에 단 한 번 만나는 데에 10만 원이 듭니다.",
    icon: cheaperImg,
  },
];

const lifetimeFeatures = [
  { icon: tool1Img, text: "디스턴싱 이론 강의", tag: "무제한" },
  { icon: tool2Img, text: "부정 경험 분석지", tag: "무제한" },
  { icon: tool3Img, text: "가치 발견 기록지", tag: "무제한" },
  { icon: tool4Img, text: "근육 이완 도구", tag: "무제한" },
  { icon: tool5Img, text: "호흡 안정화 도구", tag: "무제한" },
  { icon: tool6Img, text: "감정 조절 도구", tag: "무제한" },
  { icon: tool7Img, text: "수용 전념 명상", tag: "무제한" },
  { icon: tool8Img, text: "주의력 훈련 명상", tag: "무제한" },
  { icon: tool9Img, text: "마음 상태 검사지", tag: "무제한" },
  { icon: tool10Img, text: "전문가의 1:1 코칭", tag: "100일", isHollow: true },
];

export default function PaymentContentForever495() {
  const floatingAreaRef = useRef<HTMLDivElement>(null);
  const isInappWebview = useIsInappWebview();
  const { appVersion } = useGetDeviceInfo();

  const paddingX = 4.5;

  const [user, setUser] = useRecoilState(userAtom);

  const [paymentOrderState, setPaymentOrderState] =
    useRecoilState(paymentOrderAtom);

  const isFirstOrder = paymentOrderState?.isFirst;
  const fullWidth = isFirstOrder ? true : !!isInappWebview;

  const { refetch: getPaymentOrder } = useQuery(
    [PAYMENT_DOMAIN, PAYMENT_ORDER_DETAIL_ENDPOINT],
    () => paymentApi.getOrderDetail(),
    {
      enabled: false,
      onSuccess: (data) => {
        if (data && data.result) {
          setPaymentOrderState(data.result);
        }
      },
    }
  );

  const pageKey = "payment_1";

  const { mutate: savePage } = useMutation(
    (pageId: string) => onboardingApi.savePage(pageId),
    {
      onSuccess: () => {},
    }
  );

  const { mutate: appsflyerSendEvent } = useMutation({
    mutationFn: (eventName: string) => appsflyerApi.sendEvent(eventName),
    onSuccess: () => {},
  });

  function useEffectOnce(callback: () => void) {
    const ref = useRef(false);

    useEffect(() => {
      if (ref.current) return;
      ref.current = true;

      if (typeof callback === "function") {
        callback();
      }
    }, []);
  }

  useEffectOnce(() => {
    savePage(pageKey);
    appsflyerSendEvent("결제페이지뷰");

    if (isInappWebview && compareVersions(appVersion, "1.1.17") >= 0) {
      sendMessage(
        JSON.stringify({
          event: "send_fb_event",
          params: {
            eventName: "page_view_payment",
          },
        })
      );
    }
  });

  useEffect(() => {
    getPaymentOrder();
  }, []);

  const { companyInfoUrl, privacyPolicyUrl, servicePolicyUrl } = useGetUrls();

  useEffect(() => {
    if (isInappWebview) {
      const topBackground = extractHexColor(
        theme.vars.palette.Background.Level3
      );
      const bottomBackground = extractHexColor(
        theme.vars.palette.Background.Level1
      );

      if (topBackground && bottomBackground) {
        sendMessage(
          JSON.stringify({
            event: "set_safearea_color",
            params: {
              topColor: `${topBackground}`,
              bottomColor: `${bottomBackground}`,
            },
          })
        );
      }
    }
  }, []);

  const { homeIndicatorHeight } = useGetDeviceInfo();
  const [containerHeight, setContainerHeight] = useState<number>(
    window.innerHeight - homeIndicatorHeight
  );
  const [floatingAreaHeight, setFloatingAreaHeight] = useState<number>(0);

  useEffect(() => {
    setTimeout(() => {
      setFloatingAreaHeight(floatingAreaRef.current?.offsetHeight || 0);
    }, 100);
  }, [floatingAreaRef.current]);

  return (
    <ContentTemplateV2 noPadding isWide setContainerHeight={setContainerHeight}>
      {containerHeight > 0 && (
        <Stack
          sx={{
            pb: "150px",
            backgroundColor: theme.vars.palette.Background.Level3,
          }}
        >
          {/*영역 1: ~님의 프로그램 */}
          <Stack
            spacing={5}
            justifyContent="center"
            alignItems={"center"}
            sx={{
              width: "100%",
              maxWidth: "100%",
              mx: "auto",
              px: paddingX,
              pt: 6,
              pb: 8,
            }}
          >
            <Stack
              spacing={3}
              sx={{
                width: "100%",
                maxWidth: "720px",
                textAlign: "center",
              }}
            >
              <CustomTypography
                variant={"H1"}
                sx={{
                  paddingTop: "54px",
                  color: theme.vars.palette.Content.Strong,
                  fontWeight: 800,
                }}
              >
                {`${user?.nickname}님의 프로그램`}
              </CustomTypography>
              <CustomTypography
                variant={"Subtitle"}
                sx={{
                  color: theme.vars.palette.Content.Medium,
                  fontWeight: 500,
                }}
              >
                {"마음을 다루는 근거있고\n효과적인 방법을 제안합니다."}
              </CustomTypography>
            </Stack>

            {isFirstOrder && (
              <Stack
                spacing={"12px"}
                sx={{
                  width: "100%",
                  maxWidth: "720px",
                }}
              >
                <Box
                  sx={{
                    backgroundColor: theme.vars.palette.Surface.Forward,
                    borderRadius: "16px",
                    py: 4,
                    px: 3,
                  }}
                >
                  <CustomTypography
                    variant={"Body"}
                    sx={{
                      color: theme.vars.palette.Content.Highlight,
                      fontWeight: 700,
                    }}
                  >
                    주요 훈련 계획
                  </CustomTypography>
                  <Stack spacing={1} sx={{ mt: 2 }}>
                    {majorTrainingPlan.map((text, idx) => (
                      <Stack
                        direction={"row"}
                        spacing={0.5}
                        alignItems="center"
                      >
                        <img
                          src={numberWithCircle[idx]}
                          alt={"number"}
                          style={{}}
                        ></img>
                        <CustomTypography
                          key={idx}
                          variant={"Body"}
                          sx={{
                            p: 0,
                            color: theme.vars.palette.Content.Strong,
                            fontWeight: 500,
                          }}
                        >
                          {text}
                        </CustomTypography>
                      </Stack>
                    ))}
                  </Stack>
                </Box>

                <Box
                  sx={{
                    backgroundColor: theme.vars.palette.Surface.Forward,
                    borderRadius: "16px",
                    py: 4,
                    px: 3,
                  }}
                >
                  <CustomTypography
                    variant={"Body"}
                    sx={{
                      color: theme.vars.palette.Content.Highlight,
                      fontWeight: 700,
                    }}
                  >
                    프로그램 구성
                  </CustomTypography>
                  <Stack spacing={1} sx={{ mt: 2 }}>
                    {programFeatures.map(({ main, postLabel }, idx) => (
                      <Stack
                        key={idx}
                        direction="row"
                        alignItems="center"
                        spacing={0.5}
                      >
                        <img src={checkIconImg} alt={"checkImg"}></img>

                        <CustomTypography sx={{ p: 0 }}>
                          <CustomTypography
                            variant={"Body"}
                            sx={{
                              p: 0,
                              color: theme.vars.palette.Content.Strong,
                              fontWeight: 500,
                            }}
                          >
                            {main}
                          </CustomTypography>
                          {postLabel && (
                            <CustomTypography
                              variant={"Caption"}
                              sx={{
                                color: theme.vars.palette.Content.Medium,
                                fontWeight: 500,
                                p: 0,
                                ml: 0.5,
                              }}
                            >
                              {postLabel}
                            </CustomTypography>
                          )}
                        </CustomTypography>
                      </Stack>
                    ))}
                  </Stack>
                </Box>
              </Stack>
            )}
          </Stack>

          {/*영역2 무제한 이용권*/}
          <Stack
            justifyContent="center"
            alignItems={"center"}
            sx={{
              backgroundColor: theme.vars.palette.Surface.Highlight,
              width: "100%",
              maxWidth: "100%",
              mx: "auto",
              px: paddingX,
            }}
          >
            <Box
              sx={{
                maxWidth: "720px",
                paddingY: "60px", // 내부 여백
                width: "100%", // 임시로 폭 지정
                margin: "0 auto", // 가운데 정렬 (선택 사항)
              }}
            >
              <Stack spacing={3}>
                {/* 첫 줄(좌우 배치) */}
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="baseline"
                  sx={{
                    pr: 0.6,
                  }}
                >
                  <Stack spacing={0.2}>
                    <CustomTypography
                      variant={"H3"}
                      sx={{
                        p: 0,
                        color: theme.vars.palette.Content.Negative,
                        fontWeight: 700,
                      }}
                    >
                      무제한 이용권
                    </CustomTypography>
                    <CustomTypography
                      variant={"Body"}
                      sx={{
                        color: theme.vars.palette.Content.Negative,
                        fontWeight: 700,
                      }}
                    >
                      {"* 1:1 코칭 100일 포함"}
                    </CustomTypography>
                  </Stack>

                  <CustomTypography
                    variant={"H3"}
                    sx={{
                      p: 0,
                      color: theme.vars.palette.Content.Negative,
                      fontWeight: 700,
                    }}
                  >
                    {"495,000원"}
                  </CustomTypography>
                </Stack>

                <CustomTypography
                  variant={"Subtitle"}
                  sx={{
                    p: 0,
                    color: theme.vars.palette.Content.SoftHighlight,
                    fontWeight: 500,
                  }}
                >
                  {
                    "첫 100일 동안 매주 참여한 후에도 변화가 느껴지지 않으신다면 비용 전액을 돌려드립니다."
                  }
                </CustomTypography>
                <CustomTypography
                  variant={"Subtitle"}
                  sx={{
                    p: 0,
                    color: theme.vars.palette.Content.SoftHighlight,
                    fontWeight: 500,
                  }}
                >
                  {
                    "모든 학습 자료와 훈련 도구를 기간 제한 없이 언제든 이용할 수 있습니다."
                  }
                </CustomTypography>
              </Stack>
            </Box>
          </Stack>

          {/*추가 비용은 zero*/}
          <Stack
            py={10}
            spacing={5}
            alignItems={"center"}
            sx={{
              backgroundColor: theme.vars.palette.Content.Strong,
              width: "100%",
              mx: "auto",
              px: paddingX,
            }}
          >
            <Stack alignItems="center" spacing={6} sx={{ width: "100%" }}>
              <CustomTypography
                variant={"H2"}
                sx={{
                  color: theme.vars.palette.Content.SoftHighlight,
                  fontWeight: 700,
                  textAlign: "center",
                }}
              >
                {"1회 결제로 끝\n추가 비용은 ZERO"}
              </CustomTypography>

              <Stack
                direction="column"
                alignItems="start"
                sx={{ width: "100%", maxWidth: "720px" }}
              >
                <CustomTypographyHighlight
                  variant={"Subtitle"}
                  sx={{
                    color: theme.vars.palette.Content.SuperWeak,
                    fontWeight: 500,
                  }}
                  highlightedText={"숨은 요금 없이"}
                  highlightVariant={"Subtitle"}
                  highlightSx={{
                    color: theme.vars.palette.Content.Negative,
                    fontWeight: 700,
                  }}
                >
                  {"회기 추가에 얼마, 선생님 변경에 얼마, 검사 추가에 얼마... 지겹지 않으신가요?\n\n" +
                    "디스턴싱은 투명합니다. 숨은 요금 없이 오직 당신의 변화에만 집중합니다.\n\n" +
                    "한 번의 결제로 모든 것을 누리세요."}
                </CustomTypographyHighlight>
              </Stack>
            </Stack>
          </Stack>

          {/*영역3: 200% 페이백 보장*/}
          {isFirstOrder && (
            <Stack
              py={10}
              spacing={5}
              justifyContent="center"
              alignItems={"center"}
              sx={{
                backgroundColor: theme.vars.palette.Background.Level1,
                width: "100%",
                px: paddingX,
                mx: "auto",
              }}
            >
              <Stack
                spacing={4}
                alignItems={"center"}
                justifyContent={"center"}
              >
                <img
                  src={paybackMarkImg}
                  alt={"empty"}
                  style={{
                    width: "100%",
                    maxWidth: "121px",
                  }}
                />
                <CustomTypography
                  variant={"H2"}
                  sx={{
                    color: theme.vars.palette.Content.Strong,
                    fontWeight: 700,
                  }}
                >
                  {"효과 보장 페이백"}
                </CustomTypography>
              </Stack>

              <Stack
                direction="column"
                alignItems="start"
                spacing={2}
                sx={{ width: "100%", maxWidth: "720px" }}
              >
                <CustomTypographyHighlight
                  variant={"Subtitle"}
                  sx={{
                    color: theme.vars.palette.Content.Medium,
                    fontWeight: 500,
                  }}
                  highlightedText={"비용 전액"}
                  highlightVariant={"Subtitle"}
                  highlightSx={{
                    color: theme.vars.palette.Content.Strong,
                    fontWeight: 700,
                  }}
                >
                  {"디스턴싱 프로그램의 첫째 주 만족도는 92%. 그러나 100일 뒤 이 만족도는 98%로 더욱 높아집니다.\n\n" +
                    "첫 100일 동안 주 1회 이상 참여한 후에도 변화가 느껴지지 않으신다면 비용 전액을 돌려드립니다.\n\n" +
                    "주 1회 이상 참여하는 게 어려울 것 같나요? 그렇지 않아요. 30분 정도면 충분하고, 전담 코치 선생님이 꾸준히 프로그램에 참여할 수 있도록 도와줄 거랍니다.\n\n" +
                    "시도해서 잃을 것은 없습니다. 시도하지 않으면 변화할 기회조차 얻지 못합니다."}
                </CustomTypographyHighlight>
              </Stack>
            </Stack>
          )}

          {/*단 한번의 결심*/}
          <Stack
            py={10}
            spacing={5}
            justifyContent="center"
            alignItems={"center"}
            sx={{
              backgroundColor: theme.vars.palette.Background.Level3,
              width: "100%",
              mx: "auto",
              px: paddingX,
            }}
          >
            <Stack
              direction="column"
              alignItems="start"
              spacing={"20px"}
              sx={{ width: "100%", maxWidth: "720px" }}
            >
              <img
                src={muscleImg}
                alt={"empty"}
                style={{
                  width: "100%",
                  maxWidth: "35px",
                }}
              />
              <CustomTypography
                variant={"H2"}
                sx={{
                  p: 0,
                  color: theme.vars.palette.Content.Strong,
                  fontWeight: 700,
                }}
              >
                {"단 한번의 결심,\n평생을 바꾸는 비법"}
              </CustomTypography>
            </Stack>

            <Stack
              spacing={5}
              justifyContent="center"
              alignItems={"center"}
              sx={{ width: "100%", maxWidth: "720px" }}
            >
              <Stack
                spacing={3}
                direction="column"
                alignItems="start"
                sx={{ width: "100%" }}
              >
                <CustomTypographyHighlight
                  variant={"Subtitle"}
                  sx={{
                    color: theme.vars.palette.Content.Medium,
                    fontWeight: 500,
                    p: 0,
                  }}
                  highlightedText={"삶이 달라질 때까지"}
                  highlightVariant={"Subtitle"}
                  highlightSx={{
                    color: theme.vars.palette.Content.Strong,
                    fontWeight: 700,
                  }}
                >
                  {"디스턴싱은 한 번 배우고 끝내는 지식이 아닙니다. 앞으로의 삶을 대하는 새로운 실천적 태도입니다.\n\n" +
                    "단 한 번의 결제로, 언제든 꾸준히 연습하고 실천하세요. 당신의 삶이 달라질 때까지, 디스턴싱이 온힘을 다해 함께하겠습니다."}
                </CustomTypographyHighlight>
              </Stack>
              <Stack
                spacing={"20px"}
                sx={{
                  pt: 3,
                  ...(isInappWebview && {
                    width: "100%",
                    margin: "0 auto",
                  }),
                }}
              >
                {lifetimeFeatures.map((feature, index) => (
                  <Stack
                    gap={10}
                    key={index}
                    direction="row"
                    justifyContent="space-between"
                  >
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <img
                        src={feature.icon}
                        alt=""
                        style={{ width: "20px", height: "20px" }}
                      />
                      <CustomTypography
                        variant="Body"
                        sx={{
                          color: theme.vars.palette.Content.Strong,
                          fontWeight: 700,
                        }}
                      >
                        {feature.text}
                      </CustomTypography>
                    </Stack>
                    <Box
                      sx={{
                        backgroundColor: feature.isHollow
                          ? "transparent"
                          : theme.vars.palette.Surface.Dead,
                        border: feature.isHollow
                          ? `1px solid ${theme.vars.palette.Border.Medium}`
                          : "none",
                        borderRadius: "20px",
                        px: "10px",
                        py: "6px",
                      }}
                    >
                      <CustomTypography
                        variant="Footnote"
                        sx={{
                          color:
                            feature.isHollow === true
                              ? theme.vars.palette.Content.Strong
                              : theme.vars.palette.Content.Highlight,
                          fontWeight: 700,
                        }}
                      >
                        {feature.tag}
                      </CustomTypography>
                    </Box>
                  </Stack>
                ))}
              </Stack>
            </Stack>
          </Stack>

          {/*100일간의 집중 코칭*/}
          <Stack
            py={10}
            spacing={5}
            justifyContent="center"
            alignItems={"center"}
            sx={{
              backgroundColor: theme.vars.palette.Surface.Highlight,
              width: "100%",
              px: paddingX,
              mx: "auto",
            }}
          >
            <Stack spacing={4} alignItems={"center"} justifyContent={"center"}>
              <img
                src={focusCoachingImg}
                alt={"empty"}
                style={{
                  width: "100%",
                  maxWidth: "80px",
                }}
              />
              <CustomTypography
                variant={"H2"}
                sx={{
                  color: theme.vars.palette.Content.Negative,
                  fontWeight: 700,
                }}
              >
                {"100일간의 1:1 집중 코칭"}
              </CustomTypography>
            </Stack>

            <Stack
              direction="column"
              alignItems="start"
              spacing={2}
              sx={{ width: "100%", maxWidth: "720px" }}
            >
              <CustomTypographyHighlight
                variant={"Subtitle"}
                sx={{
                  color: theme.vars.palette.Content.SoftHighlight,
                  fontWeight: 500,
                }}
                highlightedText={"맞춤형 프로그램"}
                highlightVariant={"Subtitle"}
                highlightSx={{
                  color: theme.vars.palette.Content.Negative,
                  fontWeight: 700,
                }}
              >
                {"무제한 이용권에는 전담 코치와 함께하는 100일 집중 훈련 기간이 포함되어 있습니다.\n\n" +
                  "첫 100일 동안, 매일 코치와 함께 맞춤형 프로그램으로 디스턴싱을 집중 학습하세요.\n\n" +
                  "코칭이 끝난 뒤에도 모든 학습 자료와 훈련 도구는 기한 없이 언제든 이용할 수 있습니다."}
              </CustomTypographyHighlight>
            </Stack>
          </Stack>

          {/*변화를 위한 투자*/}
          <Stack
            py={10}
            spacing={5}
            justifyContent="center"
            alignItems={"center"}
            sx={{
              backgroundColor: theme.vars.palette.Background.Level3,
              width: "100%",
              mx: "auto",
              px: paddingX,
            }}
          >
            <Stack
              direction="column"
              alignItems="start"
              spacing={"20px"}
              sx={{ width: "100%", maxWidth: "720px" }}
            >
              <img
                src={rocketImg}
                alt={"empty"}
                style={{
                  width: "100%",
                  maxWidth: "35px",
                }}
              />
              <CustomTypography
                variant={"H2"}
                sx={{
                  p: 0,
                  color: theme.vars.palette.Content.Strong,
                  fontWeight: 700,
                }}
              >
                {"변화를 위한 투자,\n하루 4천 원"}
              </CustomTypography>
            </Stack>

            <Stack
              spacing={3}
              direction="column"
              alignItems="start"
              sx={{ width: "100%", maxWidth: "720px" }}
            >
              <CustomTypographyHighlight
                variant={"Subtitle"}
                sx={{
                  color: theme.vars.palette.Content.Medium,
                  fontWeight: 500,
                  p: 0,
                }}
                highlightedText={"커피 한 잔 가격"}
                highlightVariant={"Subtitle"}
                highlightSx={{
                  color: theme.vars.palette.Content.Strong,
                  fontWeight: 700,
                }}
              >
                {"100일 간의 코칭만으로도, 하루 4천 원 대에 불과합니다. 커피 한 잔 가격으로 당신의 삶을 완전히 바꿀 기회입니다.\n\n" +
                  "혁신적인 방법으로 완성한 전 세계 유일의 통합 인지치료, 디스턴싱. 지금 바로 시작하세요."}
              </CustomTypographyHighlight>
            </Stack>
          </Stack>

          {/*영역4: 리뷰*/}
          <Stack
            py={10}
            spacing={"30px"}
            justifyContent="center"
            alignItems={"center"}
            sx={{
              backgroundColor: theme.vars.palette.Content.Strong,
              width: "100%",
              mx: "auto",
              px: paddingX,
            }}
          >
            <Box
              sx={{
                maxWidth: "720px",
              }}
            >
              <Stack alignItems="center" spacing={6}>
                <Stack alignItems="center" spacing={2}>
                  <img
                    src={fivestarsImg}
                    alt={"empty"}
                    style={{
                      width: "100%",
                      maxWidth: "124px",
                      // objectFit: "cover",
                      // objectPosition: "50% 0%",
                    }}
                  />

                  <CustomTypography
                    variant={"H2"}
                    sx={{
                      color: theme.vars.palette.Content.SoftHighlight,
                      fontWeight: 590,
                    }}
                  >
                    200+개의 5점 리뷰
                  </CustomTypography>
                </Stack>

                {/* 후기 항목들 */}
                <Stack spacing={6} alignItems="center">
                  <ReviewItem
                    avatarIcon={reviewAvatar1Img}
                    text={"생각을 바라보는\n완전히 새로운 접근"}
                  />
                  <ReviewItem
                    avatarIcon={reviewAvatar2Img}
                    text={"신선하고 사려깊은\n과학적인 프로그램"}
                  />
                  <ReviewItem
                    avatarIcon={reviewAvatar3Img}
                    text={"지금껏 받아봤던\n인지행동치료 중 최고"}
                  />
                </Stack>
              </Stack>
            </Box>
          </Stack>

          {/*우리의 삶은 계속되니까*/}
          <Stack
            py={10}
            spacing={5}
            justifyContent="center"
            alignItems={"center"}
            sx={{
              backgroundColor: theme.vars.palette.Background.Level1,
              width: "100%",
              mx: "auto",
              px: paddingX,
            }}
          >
            <Stack
              direction="column"
              alignItems="start"
              spacing={"20px"}
              sx={{ width: "100%", maxWidth: "720px" }}
            >
              <img
                src={calendarForeverImg}
                alt={"empty"}
                style={{
                  width: "100%",
                  maxWidth: "35px",
                }}
              />
              <CustomTypography
                variant={"H2"}
                sx={{
                  p: 0,
                  color: theme.vars.palette.Content.Strong,
                  fontWeight: 700,
                }}
              >
                {"우리의 삶은\n계속되니까"}
              </CustomTypography>
            </Stack>

            <Stack
              spacing={5}
              justifyContent="center"
              alignItems={"center"}
              sx={{ width: "100%", maxWidth: "720px" }}
            >
              <Stack
                spacing={3}
                direction="column"
                alignItems="start"
                sx={{ width: "100%" }}
              >
                <CustomTypographyHighlight
                  variant={"Subtitle"}
                  sx={{
                    color: theme.vars.palette.Content.Medium,
                    fontWeight: 500,
                    p: 0
                  }}
                  highlightedText={"끊임없이"}
                  highlightVariant={"Subtitle"}
                  highlightSx={{
                    color: theme.vars.palette.Content.Strong,
                    fontWeight: 700,
                  }}
                >
                  {
                    "삶은 끊임없이 변하고, 우리는 수많은 고난을 맞닥뜨릴 수밖에 없습니다."
                  }
                </CustomTypographyHighlight>
                <CustomTypography
                  variant={"Subtitle"}
                  sx={{
                    color: theme.vars.palette.Content.Medium,
                    fontWeight: 500,
                    p: 0
                  }}
                >
                  {
                    "그래서 마음의 기술은 ‘알고 있느냐’가 아니라, ‘계속 실천하느냐’가 중요합니다."
                  }
                </CustomTypography>
                <CustomTypography
                  variant={"Subtitle"}
                  sx={{
                    color: theme.vars.palette.Content.Medium,
                    fontWeight: 500,
                    p: 0
                  }}
                >
                  {
                    "디스턴싱은 모든 학습 자료와 훈련 도구를 무제한으로 제공합니다."
                  }
                </CustomTypography>
                <CustomTypographyHighlight
                  variant={"Subtitle"}
                  sx={{
                    color: theme.vars.palette.Content.Medium,
                    fontWeight: 500,
                    p: 0
                  }}
                  highlightedText={"언제든 삶이 흔들릴 때마다"}
                  highlightVariant={"Subtitle"}
                  highlightSx={{
                    color: theme.vars.palette.Content.Strong,
                    fontWeight: 700,
                  }}
                >
                  {
                    "언제든 삶이 흔들릴 때마다, 중심을 잡고 다시 앞으로 나아갈 수 있도록 돕겠습니다."
                  }
                </CustomTypographyHighlight>
              </Stack>
              {/* 하단 그래프 */}
              <img
                src={chartForeverImg}
                alt={"empty"}
                style={{
                  width: "100%",
                  maxWidth: "321px",
                }}
              />
            </Stack>
          </Stack>

          <Stack
            py={10}
            spacing={2}
            justifyContent="center"
            alignItems="center"
            sx={{
              backgroundColor: theme.vars.palette.Background.Level3,
              width: "100%",
              maxWidth: "720px",
              mx: "auto",
              position: "relative",
              overflow: "visible",
              // 2) 이미지 높이만큼 아래 공간 확보 (예: 200px 값은 이미지 크기에 맞춰 조정)
              pb: "50px",

              // 아래 섹션과 겹치지 않도록 marginBottom 등 지정
            }}
          >
            <Stack spacing={"44px"} alignItems={"center"}>
              <CustomTypography
                variant={"Body"}
                sx={{
                  color: theme.vars.palette.Content.Medium,
                  fontWeight: 510,
                }}
              >
                {"Supported by"}
              </CustomTypography>
              <img
                src={sponsorImg}
                alt={"empty"}
                style={{
                  width: "100%",
                  maxWidth: "300px",
                  paddingBottom: "60px",
                  // objectFit: "cover",
                  // objectPosition: "50% 0%",
                }}
              />
            </Stack>
            <CustomTypography
              pt={5}
              variant="Body"
              sx={{
                color: theme.vars.palette.Content.Medium,
                fontWeight: 500,
              }}
            >
              PC, 모바일 완벽 지원
            </CustomTypography>

            {/* 3) 절대 배치 박스 (이미지를 오른쪽 밖으로) */}
            <Box
              sx={{
                // 오른쪽 끝을 삐져나가게
                mr: "-60px",
                mt: 2, // 텍스트와 간격
                width: "90%",
                alignSelf: "flex-end", // 스택의 오른쪽에 배치
              }}
            >
              <img
                src={pcAndMobileImg}
                alt="pc_and_mobile"
                style={{
                  width: "100%", // 상황에 맞게 조절
                  height: "auto",
                }}
              />
            </Box>
          </Stack>

          <Stack
            py={10}
            spacing={"30px"}
            justifyContent="center"
            alignItems={"center"}
            sx={{
              backgroundColor: theme.vars.palette.Background.Level1,
              width: "100%",
              mx: "auto",
              px: paddingX,
            }}
          >
            <Stack spacing={10} sx={{ width: "100%", maxWidth: "720px" }}>
              {comparisonItems.map(({ type, title, text, icon }) => (
                <Stack
                  spacing="40px"
                  sx={{
                    borderRadius: "12px",
                    // p: "24px",
                    // backgroundColor: "white",
                    // borderWidth: "1px",
                    // borderColor: "divider",
                  }}
                >
                  <Stack
                    spacing={"20px"}
                    direction="column"
                    alignItems="start"
                    sx={{ width: "100%" }}
                  >
                    <img
                      src={icon}
                      alt={"empty"}
                      style={{
                        width: "100%",
                        maxWidth: "35px",
                      }}
                    />
                    <Typography
                      variant={"H2"}
                      sx={{
                        p: 0,
                        color: theme.vars.palette.Content.Strong,
                        fontWeight: 700,
                      }}
                    >
                      {title}
                    </Typography>
                  </Stack>
                  <Stack spacing="40px">
                    <CustomTypography
                      variant={"Subtitle"}
                      sx={{
                        p: 0,
                        color: theme.vars.palette.Content.Medium,
                        fontWeight: 500,
                      }}
                    >
                      {text}
                    </CustomTypography>
                    <CompareWithCounselingTypeC type={type} />
                  </Stack>
                </Stack>
              ))}
            </Stack>
          </Stack>

          {isFirstOrder && (
            <Stack
              py={10}
              justifyContent="center"
              alignItems={"center"}
              sx={{
                backgroundColor: theme.vars.palette.Background.Level3,
                width: "100%",
                mx: "auto",
                px: paddingX,
              }}
            >
              <Stack spacing={5} sx={{ width: "100%", maxWidth: "720px" }}>
                <Typography
                  variant={"H2"}
                  sx={{
                    p: 0,
                    color: theme.vars.palette.Content.Strong,
                    fontWeight: 700,
                  }}
                >
                  {"자주 묻는 질문"}
                </Typography>
                <FAQTypeC />
              </Stack>
            </Stack>
          )}

          <Stack
            spacing={2}
            justifyContent="center"
            alignItems={"center"}
            sx={{
              backgroundColor: theme.vars.palette.Background.Level3,
              width: "100%",
              maxWidth: "720px",
              mx: "auto",
              px: paddingX,
              pt: isFirstOrder ? 0 : 9,
            }}
          >
            <Stack direction={"row"} spacing={3}>
              {user && <UserInfo user={user} />}
              {<CxButton type="link" />}
            </Stack>
            <Stack direction={"row"} spacing={3}>
              <LinkV2 text={"사업자 정보"} url={companyInfoUrl} />
              <LinkV2 text={"개인정보 처리방침"} url={privacyPolicyUrl} />
              <LinkV2 text={"서비스 이용약관"} url={servicePolicyUrl} />
            </Stack>
          </Stack>

          <Box>
            <FloatingArea fullWidth={fullWidth} ref={floatingAreaRef}>
              <Stack
                spacing={1.5}
                sx={{ width: "100%" }}
                alignItems="center"
                justifyContent={"space-between"}
              >
                <CustomTypography
                  variant={"Caption"}
                  sx={{
                    p: 0,
                    fontWeight: 500,
                    color: theme.vars.palette.Content.Medium,
                  }}
                >
                  {
                    "무제한 495,000원\u00A0\u00A0|\u00A0\u00A0불만족시 전액 페이백"
                  }
                </CustomTypography>
                {paymentOrderState && <PaymentButton />}
              </Stack>
            </FloatingArea>
          </Box>
        </Stack>
      )}
    </ContentTemplateV2>
  );
}